export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: 'a387145a-0047-4c7d-b146-edf999ecf9eb'
  },
  apiSite: 'http://webapi.softdiamond.co.uk/'
};
